import { FunctionComponent } from "react";
import { Avatar, Button, Dropdown, MenuProps } from "antd";
import { MenuFoldOutlined, MenuOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../hooks/AuthContext";

interface TopBarProps {
    title: string;
    isMobile: boolean;
    collapsed: boolean;
    onToggle: () => void;
}

export const TopBar: FunctionComponent<TopBarProps> = ({ title, isMobile, collapsed, onToggle }) => {
    const { username, prenom, logout } = useAuth();
    const navigate = useNavigate();

    const items: MenuProps["items"] = [
        { key: "changePassword", label: "Modifier mot de passe", ...({ testid: "menu-change-password" } as any) },
        { key: "logout", label: "Se déconnecter", ...({ testid: "menu-logout" } as any) },
    ];

    const onMenuClick: MenuProps["onClick"] = ({ key }) => {
        if (key === "logout") logout?.();
        else if (key === "changePassword") navigate("/changePassword");
    };

    const toggleIcon = isMobile ? <MenuOutlined /> : collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />;

    return (
        <div className="app-topbar">
            <div className="app-topbar-left">
                <Button type="text" aria-label="Menu" icon={toggleIcon} onClick={onToggle} />
                <span className="app-topbar-title">{title}</span>
            </div>
            <Dropdown menu={{ items, onClick: onMenuClick }}>
                <Avatar style={{ backgroundColor: "orange", color: "black", cursor: "pointer" }} {...({ testid: "avatar-utilisateur" } as any)}>
                    {prenom ?? username}
                </Avatar>
            </Dropdown>
        </div>
    );
};
